
import csstype.ClassName
import react.FC
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h3
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.p

val CareDiv = FC<CareProps> { props ->
    div {
        id = "stoneCarediv"
        if (props.stoneType == "granite" || props.stoneType == "marble" || props.stoneType == "limestone") {
            div {
                className = ClassName("row")
                div {
                    className = ClassName("columnleft")
                    h3 {
                        +"""
                        ${props.stoneType.replaceFirstChar { it.uppercase() }} Care and Precautions 
                    """.trimIndent()
                    }
                    p {
                        + """
                        Use coasters under all glasses and drinks. 
                        Do not place hot items directly on the ${props.stoneType} countertop surface. 
                        Use trivets or mats under 
                        hot dishes and placements ceramics or other objects that can scratch the surfaces.
                    """.trimIndent()
                    }
                }
                div {
                    className = ClassName("columnimg")
                    img {
                        src = "images/big32.gif"
                    }
                }
            }
            div {
                className = ClassName("row")
                div {
                    className = ClassName("carecenter")
                    h3 {
                        + "Cleaning Procedures and Recommendations"
                    }
                    p {
                        + """
                        Clean ${props.stoneType} countertop surfaces with a few drops of neutral cleaner, 
                        stone cleaner or mild liquid dishwashing detergent and warm water.
                        Use clean rag mop on floors and a soft cloth for other surface for best results. 
                        Too much cleaner or soap may leave a film and cause streaks. Do not use cleaner products that lemon, 
                        vinegar or other acids on ${props.stoneType} or other calcareous stones. 
                        Rinse the surface thoroughly after washing with the soap solution and dry with a soft cloth. 
                        Change the rinse water frequently. Do not use powders or creams; 
                        these cleaning products may contain abrasives that may scratch the ${props.stoneType} countertop.
                    """.trimIndent()
                    }
                }
            }
            div {
                className = ClassName("row")
                div {
                    className = ClassName("columnimg")
                    img {
                        src = "images/MV028.jpg"
                    }
                }
                div {
                    className = ClassName("columnright")
                    h3 {
                        + "For Spills and Stains"
                    }
                    p {
                        + """
                        Blot the spill with a paper towel immediately. Don’t wipe the area 
                        otherwise it will spread the spill. 
                        Flush the area with pain water and mild soap and rinse several times. 
                        Dry the area thoroughly with a soft cloth. Repeat again as necessary. 
                        If the stain remains, give us a call or identifying the type of stain on the surface 
                        since it is the key to removing it. 
                        Surface stains can often be removed by cleaning with an appropriate cleaning product
                        or household chemical. 
                        Deep seated stains may require using a poultice or calling in for our professional service.
                    """.trimIndent()
                    }
                }
            }
        }
        else {
            div {
                className = ClassName("row")
                div {
                    className = ClassName("columnleft")
                    h3 {
                        + "Quartz's Care and Precautions"
                    }
                    p {
                        + """
                            Quartz or engineered stone surfaces is very easy to maintain and clean. 
                            The advancement of technology along with the finest natural quartz creates 
                            a surfacing material with all the beauty of nature. 
                            Quartz surfaces are non-porous material that is highly stained, scratch and heat resistant. 
                        """.trimIndent()
                    }

                }
                div {
                    className = ClassName("columnimg")
                    img {
                        src = "images/small6.gif"
                    }
                }
            }
            div {
                className = ClassName("row")
                div {
                    className = ClassName("carecenter")
                    h3 {
                        + "Care and Maintenance"
                    }
                    p {
                        + """
                            Simply clean up any spill with soap and water. 
                            For routine cleaning, use small amount of cleaners that are non-blench and 
                            nonabrasive along with warm water and damp cloth on regular basis to keep the lustrous gloss 
                            and radiant sheen. Although Quartz surface is stain resistant, 
                            any type of spills should be cleaned as soon as possible. 
                            Any liquid spills, fruits, vegetables or other foods should be wiped up and cleaned 
                            with soap and water. 
                        """.trimIndent()
                    }
                }
            }
            div {
                className = ClassName("row")
                div {
                    className = ClassName("columnimg")
                    img {
                        src = "images/NGC079.jpg"
                    }
                }
                div {
                    className = ClassName("columnright")
                    h3 {
                        + "Preventing Damages"
                    }
                    p {
                        + """
                            Since Quartz surfaces are designed to be extremely resistant to heat and 
                            can withstand exposure to normal cooking environment for brief period of time 
                            without being damaged. Although Quartz is more resistant to heart compared to most 
                            of the surfacing materials in the marketplace. 
                            Trivets and hot pads should be used when placing hot skillets, 
                            pans or other hot items generating appliances on the surface.
                        """.trimIndent()
                    }
                }
            }
            div {
                className = ClassName("row")
                div {
                    className = ClassName("carecenter")
                    p {
                        + """
                            Since quartz durable surface is designed to withstand the normal use. 
                            While it is resistant to scratches, cuts and chipping, cutting directly on the Quartz 
                            surface should be avoided. Using cutting boards and taking care not to drop or move 
                            heavy object on the surface will help to ensure the long lasting of quartz surface.
                        """.trimIndent()
                    }
                }
            }
            div {
                className = ClassName("row")
                div {
                    className = ClassName("columnleft")
                    p {
                        + """
                            Some of the chemical can cause damage to the quartz surface. 
                            Avoid using any strong chemicals and solvents on quartz surfaces. 
                            It is important to note some of these chemicals and solvents can be found from household 
                            items such as paints removers, furniture cleaners, oil soaps, markers, 
                            inks and paint etc. If any of the chemical spill on the quartz surface, 
                            rinse with water and follow cleaning procedures immediately. 
                        """.trimIndent()
                    }
                }
                div {
                    className = ClassName("columnimg")
                    img {
                        src = "images/big32.gif"
                    }
                }
            }
            div {
                className = ClassName("row")
                div {
                    className = ClassName("carecenter")
                    p {
                        + """
                            For the removal of difficult spills, if normal cleaning procedures do not work, 
                            use nonabrasive cleaning pad along with common cleaners. 
                            If gum, paint or other similar substances are accidentally allowed to adhere to the surface, 
                            they can removed by using of plastic scraper to gently scrap off the substance 
                            and following by normal cleaning procedures.
                        """.trimIndent()
                    }
                }
            }
        }
    }
}
